import CookiesJS from 'cookies-js';

export function initProgramms($, apiClient) {
    $('form.programm-form .action__entity-save').on('click', async function () {
        try {
            const _id = $(this).attr('data-object-id');
            const recipes = [];
            $('#recipes .array-item').each(function () {
                recipes.push({
                    recipeId: $(this).find('select.recipeId').val(),
                    mealType: parseInt($(this).find('select.mealType').val()),
                    adjustFactor: parseFloat($(this).find('.adjustFactor').val())
                });
            });
            const programm = {
                status: parseInt($('#status').val()),
                title: $('#title').val(),
                comment: $('#comment').val(),
                userParams: {
                    sex: parseInt($('#sex').val()) || undefined,
                    deficit: parseInt($('#deficit').val()) || undefined,
                    height: parseInt($('#height').val()) || undefined,
                    weight: parseInt($('#weight').val()) || undefined,
                    age: parseInt($('#age').val()) || undefined,
                    meals: [
                        !!$('#meals0').prop('checked'),
                        !!$('#meals1').prop('checked'),
                        !!$('#meals2').prop('checked'),
                        !!$('#meals3').prop('checked'),
                        !!$('#meals4').prop('checked'),
                        !!$('#meals5').prop('checked')
                    ],
                    activityCoefficient: $('#activityCoefficient').val() || undefined,
                    maxRecipeDifficulty: $('#maxRecipeDifficulty').val() || undefined,
                    maxRecipePrice: $('#maxRecipePrice').val() || undefined,
                    disallowedProducts: $('#disallowedProducts').val() || undefined,
                    disallowedKitchenware: $('#disallowedKitchenware').val() || undefined,
                },
                recipes,
                deleted: !!$('#deleted').prop('checked'),
            };
            const userId = $('#userId').val();
            if (userId) {
                programm.userId = userId;
            }
            if (!_id) {
                const result = await apiClient.create('/programms', programm, CookiesJS.get('auth_token'));
                console.log(result);
                document.location.href=`/programms/edit/${result._id}`;
            } else {
                const result = await apiClient.updateOne('/programms', _id, programm, CookiesJS.get('auth_token'));
                console.log(result);
                alert('Сохранено');
                location.reload();
            }
        } catch(e) {
            console.warn(e);
            if (e.response
                && e.response.data
                && e.response.data.errors
                && e.response.data.errors[0]
                && e.response.data.errors[0].msg
            ) {
                alert(`${e.response.data.errors[0].msg}: ${e.response.data.errors[0].param}`);
            } else {
                alert(e);
            }
        }
    });
}
